module.exports = __webpack_public_path__ + "static/media/Screeshot.1cb92971.jpg";